import { render, staticRenderFns } from "./ScrollDownButton.vue?vue&type=template&id=f7fcda58&scoped=true"
import script from "./ScrollDownButton.vue?vue&type=script&lang=ts"
export * from "./ScrollDownButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fcda58",
  null
  
)

export default component.exports